import { useTranslation } from "react-i18next";

import { ErrorBox } from "./error-box";

interface FormErrorBoxProps {
  error: Error | string | null;
  newStyle?: boolean;
  dataTestId?: string;
}

export const FormErrorBox = (props: FormErrorBoxProps) => {
  const { error } = props;
  const { t } = useTranslation();
  let title: string | undefined;
  let message: string;

  if (!error) {
    message = t("error_somethingWentWrong");
  } else {
    const isStringError = typeof error === "string";
    title = t("error");
    message = isStringError ? error : error.message || "";
  }

  return (
    <div className="mb-5" data-testid={props.dataTestId}>
      <ErrorBox title={title} text={message} />
    </div>
  );
};
